export default function IconUnread() {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="12"
      viewBox="0 0 18 12"
    >
      <g fill="#54545A">
        <path d="M12.549 2.228L12.507 2.204 12.537 2.239z" />
        <path d="M15.944.22c-.208-.251-.58-.289-.834-.083l-1.59 1.298C12.185.527 10.614.028 9 0 5.175 0 2.215 2.978.87 4.598c-.375.444-.375 1.093 0 1.537.935 1.136 2.024 2.139 3.234 2.978L2 10.84c-.252.208-.289.58-.083.834.11.146.281.234.464.238.138.002.272-.047.376-.137l2.436-1.99 1.625-1.334 1.668-1.364 2.222-1.786 1.53-1.251 2.281-1.87 1.335-1.096c.13-.1.214-.249.231-.413.017-.163-.034-.326-.142-.45zM4.169 5.36c.002 1.052.351 2.074.995 2.907l-.09.071C3.833 7.52 2.724 6.515 1.787 5.36c.99-1.203 2.171-2.235 3.496-3.055-.72.855-1.116 1.937-1.114 3.055zm4.967-.34c-.13-.154-.202-.35-.202-.553 0-.352.207-.67.53-.81-.171-.055-.35-.083-.53-.083-.662.005-1.267.376-1.572.964-.305.588-.259 1.297.119 1.84L6.093 7.51c-.476-.615-.734-1.372-.733-2.15-.005-1.486.911-2.821 2.3-3.35 1.39-.53 2.962-.145 3.948.968L9.136 5.02zM16.992 4.586c-.487-.579-1.006-1.13-1.554-1.65l-2.93 2.424c0 1.974-1.6 3.574-3.574 3.574-.246.001-.492-.025-.733-.078L6.414 10.31c.786.27 1.611.408 2.442.41 3.818 0 6.784-2.977 8.13-4.597.376-.443.379-1.092.006-1.537zM12.58 8.422c.588-.703.964-1.558 1.084-2.466l1.697-1.388c.238.256.483.53.727.81-.996 1.2-2.18 2.227-3.508 3.044z" />
      </g>
    </svg>
  );
}
